import CrudCustom from '../../../libs/custom/CrudCustom';

let Spt1771Service = new CrudCustom('/spt-1771');
export default Spt1771Service;
